// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3s_K8","open":"open___2Bhyl","modalHeader":"modalHeader___18QVw","modalcontent":"modalcontent___Nd1C6","errorDetails":"errorDetails___3JTxz"};